import { render, staticRenderFns } from "./SetGroups.vue?vue&type=template&id=c93cd534"
import script from "./SetGroups.vue?vue&type=script&lang=js"
export * from "./SetGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports